import {Feature} from '@kakaoent/feature-flag';

let _feature: Feature;

export function initializeKakaopageFeature(feature: Feature) {
  _feature = feature;
}

export function getKakaopageFeature() {
  return _feature;
}
